import {Component} from '@angular/core';
import { ProfileItem, profilesAccess } from './constants';

@Component({
  selector: 'app-alarms',
  templateUrl: './access.component.html',
  styleUrls: ['./access.css']
})

export class AccessComponent {
  private profiles: ProfileItem[] = profilesAccess
}



// WEBPACK FOOTER //
// ./src/app/access/access.component.ts